import React from 'react';
import { Typography } from 'antd';
import { CaretUpFilled, CaretDownFilled, ExclamationCircleFilled } from '@ant-design/icons';

import { percentageFormatter } from '../Chart';
import { CustomTooltip } from '../../../components/Tooltip';
import {
  getKPIComparisonTooltipMessage,
  type KPIComparison,
} from './KPIComparison';

function Percentage({
  comparison,
  color,
}: {
  comparison: KPIComparison;
  color: 'success' | 'danger';
}) {
  if (comparison.kind !== 'delta') {
    return (
      <Typography.Text strong>
        <span style={{ marginRight: 4 }}>N/A</span>
        <CustomTooltip
          placement="top"
          message={getKPIComparisonTooltipMessage(comparison)}
        >
          <ExclamationCircleFilled />
        </CustomTooltip>
      </Typography.Text>
    );
  }

  return (
    <Typography.Text strong type={color}>
      {percentageFormatter(comparison.percentage)}{' '}
      {comparison.percentage > 0 ? <CaretUpFilled /> : <CaretDownFilled />}
    </Typography.Text>
  );
}
export default Percentage;
